import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { gql, useQuery } from "@apollo/client";
import { Button, Input, Layout, PageHeader, Space, Table, Tooltip } from "antd";
import { first, last } from "lodash";
import moment from "moment";
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

const measureSizeGroupsQuery = gql`
  query ($pagination: ConnectionPagination, $searchQuery: String) {
    measureSizeGroups(pagination: $pagination, searchQuery: $searchQuery) {
      nodes {
        id
        code
        sizes {
          id
          code
          value
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        page
        size
      }
      totalCount
      totalPages
    }
  }
`;

export const List: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const variables = {
    pagination: { page: 1, pageSize: 0 },
    orderBy: { direction: "ASC", field: "ID" },
    searchQuery,
  };
  const { loading, data } = useQuery(measureSizeGroupsQuery, { variables, fetchPolicy: "cache-and-network" });

  const handleSearch = (value: string) => setSearchQuery(value);
  const handleSearchCancel = () => setSearchQuery("");
  const handleTableChange = () => {};

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      sorter: (a: any, b: any) => a.code.localeCompare(b.code),
    },
    {
      title: "Sizes",
      render: (value: string, resource: any) => {
        if (!!resource.sizes.length)
          return (
            <Fragment>
              {first(resource.sizes).code} - {last(resource.sizes).code}
            </Fragment>
          );
      },
    },
    {
      title: "Created At",
      render: (resource: any) => moment(resource.insertedAt).format("DD-MM-YYYY"),
    },
    {
      width: "80px",
      title: "Actions",
      dataIndex: "id",
      render: (id: string, resource: any) => (
        <Tooltip title="Edit">
          <Button onClick={() => navigate(`${id}/edit`)} icon={<EditOutlined />}></Button>
        </Tooltip>
      ),
    },
  ];

  return (
    <Fragment>
      <Layout.Header className="header-background">
        <Input.Search
          placeholder="search"
          onSearch={handleSearch}
          key={variables.searchQuery ?? "__search__"}
          defaultValue={variables.searchQuery ?? ""}
          style={{ width: 500, margin: "16px 30px" }}
        />
        <Button disabled={searchQuery.length === 0} onClick={handleSearchCancel} style={{ margin: "16px 0" }}>
          Cancel
        </Button>
      </Layout.Header>
      <Layout className="content">
        <PageHeader
          ghost={true}
          title="Size Groups"
          extra={
            <Space size="large">
              <Button onClick={() => navigate("..")}>Back</Button>
              <Button
                onClick={() => {
                  navigate("new");
                }}
                type="primary"
              >
                <PlusOutlined />
                New
              </Button>
            </Space>
          }
        />
        <Layout.Content className="content">
          <Table
            rowKey="id"
            loading={loading}
            columns={columns}
            dataSource={data?.measureSizeGroups.nodes}
            pagination={{
              hideOnSinglePage: true,
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range} of ${total}`,
              total: data?.totalCount ?? 0,
            }}
            onChange={handleTableChange}
          />
        </Layout.Content>
      </Layout>
    </Fragment>
  );
};
